module.exports = __webpack_public_path__ + "logo.537211e7.svg";